import React from "react";
import {FormGroup} from "../../form/group/index";
import {Input} from "../../form/input/index";
import {Button} from "../../button/index";
import { FaCopy, FaTrash } from "react-icons/fa";
import InputMask from "react-input-mask";
import {InputBox} from "../../form/input.box/index";
import {Tooltip} from "../../tooltip/index";
import {Checkbox} from "../../form/checkbox";
import {DatePicker} from "../../form/date.picker.input";
import {FORMATS} from "../../../../common/utils/core/formats";
import {IntlStore} from "../../../../intl/src/store";
import {getWeekdayFromMomentISOIndex} from "../../../../common/utils/dates/weekDayFromMomentISOIndex";

type ItemType = BusinessSpecialHoursSlot;
type ListType = ItemType[];

export interface ComponentProps {
  hours: ListType;
  onChange: (h: ListType) => void;
  intl: IntlStore;
}

export class FieldSpecialHours extends React.Component<ComponentProps, {}> {

  add = () => {

    const hours = [ ...this.props.hours ];

    const date = this.props.intl.momentNow();

    hours.push({
      date: date.format(FORMATS.moment.date),
      day: getWeekdayFromMomentISOIndex(date.isoWeekday()),
      opened: true,
      open: "09:00",
      close: "21:00",
      h24: false,
    });

    this.props.onChange(hours);

  }

  copy = (i: number) => {
    const hours = [ ...this.props.hours ];
    hours.splice(i, 0, { ...hours[i] });
    this.props.onChange(hours);
  }

  remove = (i: number) => {
    const hours = ([ ...this.props.hours ]);
    hours.splice(i, 1);
    this.props.onChange(hours);
  }

  update = (i: number, update: Partial<BusinessSpecialHoursSlot>) => {
    const hours = [ ...this.props.hours ];
    hours[i] = { ...hours[i], ...update };
    this.props.onChange(hours);
  }

  render() {
    const { hours, intl } = this.props;
    const { update, remove, copy } = this;
    return (
      <div>

        <Button color="primary-inverse" size="xs" type="button" onClick={this.add}>
          Add Special Hours Slot
        </Button>

        {hours.length > 0 && (
          <>
            <div className="flex-line m-t-4" style={{ alignItems: "flex-end" }}>
              <FormGroup
                style={{ width: "150px" }}
                className="m-b-0"
                title={"Date"}
                small_title={true}
                no_border={true}/>
              <FormGroup
                style={{ width: "75px" }}
                className="m-b-0"
                title={"Opened"}
                small_title={true}
                no_border={true}/>
              <FormGroup
                style={{ width: "75px" }}
                className="m-b-0"
                title={"24 Hour"}
                small_title={true}
                no_border={true}/>
              <FormGroup
                style={{ width: "100px" }}
                className="m-b-0"
                title={"Open Time"}
                small_title={true}
                no_border={true}/>
              <FormGroup
                style={{ width: "100px" }}
                className="m-b-0"
                title={"Close Time"}
                small_title={true}
                no_border={true}/>
            </div>

            {hours.map((h, i) => (
              <div key={i} className="flex-line" style={{ alignItems: "flex-end" }}>
                <div className="flex-line" style={{ alignItems: "flex-end" }}>

                  <FormGroup
                    style={{ width: "150px" }}
                    className="m-b-0"
                    no_border={true}>
                    <DatePicker
                      date={intl.momentFromFormat(h.date, FORMATS.moment.date).toDate()}
                      displayFormat={intl.s.formats.date}
                      locale={intl.s.locale}
                      timezone={intl.s.tz}
                      onSelect={(value) => {
                        update(i, {
                          date: value.date,
                          day: getWeekdayFromMomentISOIndex(value.moment.isoWeekday()),
                        });
                      }}
                    />
                  </FormGroup>

                  <FormGroup
                    className="m-b-0"
                    no_border={true}>
                    <InputBox className="no-round flex-center width75">
                      <Checkbox
                        id={`${i}-special-hours-opened-checkbox`}
                        checked={h.opened}
                        onChange={(e) => update(i, { opened: e.target.checked })}/>
                    </InputBox>
                  </FormGroup>

                  <FormGroup
                    className="m-b-0"
                    no_border={true}>
                    <InputBox className="no-round flex-center width75">
                      <Checkbox
                        id={`${i}-24-special-hours-checkbox`}
                        checked={h.h24}
                        onChange={(e) => update(i, { h24: e.target.checked })}/>
                    </InputBox>
                  </FormGroup>

                  <FormGroup
                    className="m-b-0"
                    no_border={true}>
                    <InputMask mask="99:99" value={h.open} onChange={(e) => update(i, { open: e.target.value })} disabled={!h.opened || h.h24}>
                      {(inputProps: any) => <Input type="text" className="no-round" style={{ width: "100px" }} placeholder="00:00" {...inputProps} disabled={!h.opened || h.h24}/>}
                    </InputMask>
                  </FormGroup>

                  <FormGroup
                    className="m-b-0"
                    no_border={true}>
                    <InputMask mask="99:99" value={h.close} onChange={(e) => update(i, { close: e.target.value })} disabled={!h.opened || h.h24}>
                      {(inputProps: any) => <Input type="text" className="no-round" style={{ width: "100px" }} placeholder="00:00" {...inputProps} disabled={!h.opened || h.h24}/>}
                    </InputMask>
                  </FormGroup>

                </div>
                <Tooltip text="Copy" width={65} position="top" disable={i !== 0}>
                  <Button type="button" className="no-round" paddinglr={5} color="white" onClick={() => copy(i)}>
                    <FaCopy/>
                  </Button>
                </Tooltip>
                <Tooltip text="Delete" width={65} position="top" disable={i !== 0}>
                  <Button type="button" className="no-round" paddinglr={5} color="white" onClick={() => remove(i)}>
                    <FaTrash/>
                  </Button>
                </Tooltip>
              </div>
            ))}
          </>
        )}

      </div>
    );
  }

}
